// src/utils/monthUtils.js

export function getMonthRangesForYear(year) {
  const y = String(year);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return monthNames.map((name, index) => {
    const m = String(index + 1).padStart(2, "0");
    const gte = `${y}-${m}-01T00:00:00.000Z`;
    const lastDay = new Date(Number(y), index + 1, 0).getDate();
    const d = String(lastDay).padStart(2, "0");
    const lte = `${y}-${m}-${d}T23:59:59.999Z`;

    return {
      name,
      createdAt: { $gte: gte, $lte: lte },
    };
  });
}
